import * as React from "react";
import ConfirmModal from "./confirm.modal";
import type { ModalComponentProps } from "../../types/modal.types";
import FileDragAndDrop from "../layout/file-drag";
import axios from "axios";

interface FileUploadModalProps extends ModalComponentProps {
  title?: string;
  fileDescription?: string;
  fileSubject?: string;
  click?: (files: File[]) => void;
  delete?: () => void;
  fileUrl?: string;
}

export default function FileUploadModal(props: FileUploadModalProps) {
  const { id, onClose, title, fileDescription, fileSubject, click, fileUrl, delete: deleteFile } = props;
  const [files, setFiles] = React.useState<File[]>([]);

  const fileBlob = async () => {
    if (!fileUrl) return;

    try {
      const response = await axios.get(fileUrl, { responseType: "blob" });

      const rawFileName = decodeURIComponent(fileUrl.split("/").pop()?.split("?")[0] || "");

      let cleanFileName = rawFileName.replace(/^\d{10,}/, "");

      if (!cleanFileName || cleanFileName.startsWith('.')) {
        cleanFileName = rawFileName;
      }

      const blob = response.data;
      const file = new File([blob], cleanFileName, {
        type: blob.type,
        lastModified: Date.now(),
      });

      setFiles([file]);
    } catch (error) {
      console.error("파일 로드 실패:", error);
    }
  };

  React.useEffect(() => {
    fileBlob();
  }, [fileUrl]);

  return (
    <ConfirmModal
      title={`${title}`}
      className="w-[600px]"
      onClose={onClose}
      rightButton={{
        title: "저장",
        onClick: () => {
          click?.(files);
          onClose?.();
        },
      }}
      id={id}
    >
      <div className="mt-[16px] mx-6">
        <FileDragAndDrop fileSubject={fileSubject} fileDescription={fileDescription} uploadFiles={setFiles} fileData={files} deleteFile={deleteFile} />
      </div>
    </ConfirmModal>
  );
};
